<template>
  <form ref="editarForm" @submit.prevent="submitEditForm">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <FloatLabel variant="on">
            <InputText id="descricao" v-model="dado.descricao" size="small" style="width: 100%"
                       :invalid="campoVazio.includes('descricao')" autofocus/>
            <label for="descricao"><strong>Descrição: <span class="text-danger font-bold">*</span></strong></label>
          </FloatLabel>
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <FloatLabel variant="on">
            <Textarea id="descritivo" v-model="dado.descritivo" variant="filled" rows="4" cols="110"/>
            <label for="descritivo"><strong>Descritivo: </strong></label>
          </FloatLabel>
        </div>
      </div>
    </div>
    <div class="ibox-footer">
      <div class="float-right">
        <button type="submit" class="btn btn-primary font-bold">Confirmar</button>
      </div>
      <button class="btn btn-danger font-bold" @click="$emit('fechar')">
        Cancelar
      </button>
    </div>
  </form>
</template>

<script>
import {apiRequest} from "../../../public/js/utils/funcoes";
import {apiUrl} from "@/router/apiBackRoutes";


export default {
  name: "EditarModelo",
  props: {
    itemKey: String,
  },
  data() {
    return {
      dado: 1,
      erro: null,
      campoVazio: [],
    }
  },
  emits: ["fechar", "atualizarDados"],
  methods: {
    async getDados() {
      const resultado = await apiRequest("GET", apiUrl.modelos.retrieveUpdateDestroy(this.itemKey));
      if (resultado.success) {
        this.dado = resultado.data;
      } else {
        this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        console.error("Erro ao carregar:", resultado.error);
      }
    },
    async submitEditForm() {
      // Remover campos formatados/somente leitura antes do envio
      const payload = { ...this.dado };
      delete payload.orcamento;
      delete payload.imagem_default;

      const resultado = await apiRequest("PATCH", apiUrl.modelos.retrieveUpdateDestroy(this.itemKey), payload);
      if (resultado.success) {
        this.$emit("atualizarDados", resultado.data);
        this.$toastMessage("success", "Registro alterado com sucesso!");
        this.$emit('fechar');
      } else {
        this.campoVazio = Object.keys(resultado.error);
        if (resultado.error && typeof resultado.error === "object") {
          for (const campo in resultado.error) {
            resultado.error[campo].forEach(msg => {
              this.$toastMessage("error", campo, msg);
            });
          }
        } else {
          this.$toastMessage("warn", "Atenção", "Erro inesperado ao salvar!");
        }
      }
    },
  },
  mounted() {
    this.getDados();
  },
}
</script>
